import { DetailsList, ICommandBarItemProps, IDialogContentProps, Selection, DetailsListLayoutMode, SelectionMode, CheckboxVisibility, IColumn, IDetailsListStyles, DetailsHeader, CommandBar, MessageBar, mergeStyleSets, ICommandBarStyles, IButtonProps, MessageBarType, DialogType, Dialog, DialogFooter, PrimaryButton, DefaultButton, Icon, ContextualMenu, IContextualMenuItem, TooltipHost, Pivot, PivotItem, IDragDropContext, IDragDropEvents, IPivotStyles, ITooltipHostStyles, TooltipOverflowMode } from '@fluentui/react';
import React from 'react'
import { connect, ConnectedProps } from 'react-redux';
import { RouteComponentProps } from 'react-router-dom';
import { checkRoles } from '../../../hoc/CheckRoles';
import { RoleContext } from '../../../shared/enums';
import { IAooProtocolView, IColonnaGenerale, IColumnInternalName } from '../../../shared/interfaces';
import { RootState } from '../../../store';
import CircleLoader from '../../Loader/CircleLoader/CircleLoader';
import abilityBuild from '../../../shared/CASL/appAbility';
import { subject, Unsubscribe } from "@casl/ability";
import CustomCommandBarMenuItem from '../../CustomFluentUI/CustomCommandBarMenuItem/CustomCommandBarMenuItem';
import aooProtocolViewsService from '../../../services/aooProtocolViews.service';
import { toastRef } from '../../Layout/Layout';
import AddEditAooProtocolViewManager from './AddEditAooProtocolViewManager';

import { myTheme } from '../../../assets/styles/my-theme';

const { palette } = myTheme;


const classNames = mergeStyleSets({
    iconField: {
        width: '30px',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        fontSize: '16px',
        padding: 0,
        color: palette.themePrimary,
        cursor: 'pointer'

    }

});

const commandBarStyles: Partial<ICommandBarStyles> = {
    root: { padding: '0 24px', borderBottom: '1px solid #eee' },
};

const tooltipHostStyles: Partial<ITooltipHostStyles> = {
    root: {
        display: 'inline-block',
        maxWidth: '100%',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap'

    }
};

const pivotStyles: Partial<IPivotStyles> = {
    itemContainer: {
        display: 'flex',
        flexDirection: 'column',
        overflow: 'hidden',
        height: '100%',
        position: 'relative',


        '> div': {
            display: 'flex',
            flexDirection: 'column',
            overflow: 'hidden',
            height: '100%',
            position: 'relative',
        }
    }

}



const overflowProps: IButtonProps = {
    menuProps: {
        contextualMenuItemAs: CustomCommandBarMenuItem,
        items: []
    },
};

const mapState = (state: RootState) => ({
    currentAoo: state.sessionReducer.currentAoo,
    currentUser: state.sessionReducer.currentUser,
    features: state.sessionReducer.features,
    allRoles: state.sessionReducer.allRoles,
    isMobile: state.sessionReducer.isMobile,
})

const mapDispatch = {

}

const connector = connect(mapState, mapDispatch);

type PropsFromRedux = ConnectedProps<typeof connector>

export interface AooProtocolViewManagerProps {

}

type Props = AooProtocolViewManagerProps & RouteComponentProps & PropsFromRedux;

export interface AooProtocolViewManagerState {
    commandBarItems: ICommandBarItemProps[]
    aooProtocolViews: IAooProtocolView[]
    items: IColumnInternalName[]
    columns: IColumn[]
    selectedAooProtocolView?: IAooProtocolView
    selectedColumnInternalName?: IColumnInternalName
    lateralPanelIsOpen: boolean
    lateralPanelBodyContent: Function
    lateralPanelSubmitFunction: Function
    confirmDialogIsOpen: boolean
    confirmDialogContentProps: IDialogContentProps
    confirmDialogSubmitFunction: Function
    loadingAooProtocolViewsList: boolean
    showMessageBar: boolean,
    userMessageError: string,
    showContextualMenu: boolean
    contextMenuItems: IContextualMenuItem[] | undefined
    contextMenuPosition: any
    mouseDirection?: 'up' | 'down';
    lastMouseY?: number;
}
class AooProtocolViewManager extends React.Component<Props, AooProtocolViewManagerState> {
    cancelTokenSources = {};
    unsubscribeFromAbility: Unsubscribe = () => { };
    private columnInternalNameSelection: Selection;
    private _dragDropEvents: IDragDropEvents;
    private _draggedItem: IColumnInternalName | undefined;
    private _draggedIndex: number;

    constructor(props) {
        super(props);
        this.onPivotLinkClick = this.onPivotLinkClick.bind(this);

        this.columnInternalNameSelection = new Selection({
            onSelectionChanged: () => {
                const selection = this.columnInternalNameSelection!.getSelection()[0] as IColumnInternalName;
                this.setState({ selectedColumnInternalName: selection })
            }
        })
        this._dragDropEvents = this.getDragDropEvents();
        this._draggedIndex = -1;

        this.state = {
            commandBarItems: [],
            aooProtocolViews: [],
            items: [],
            columns: [
                {
                    key: 'removeColumn',
                    name: 'removeColumn',
                    fieldName: 'removeColumn',
                    isIconOnly: true,
                    minWidth: 18,
                    maxWidth: 18,
                    onRender: (item, index) => {
                        return <div key={`remove-column-${index}`} className={classNames.iconField} >
                            <TooltipHost content="Rimuovi colonna">
                                <Icon iconName="Trash" onClick={() => { this.deleteColumnHandler(item) }} />
                            </TooltipHost>
                        </div>
                    }
                },
                {
                    key: 'index',
                    fieldName: 'index',
                    name: 'Indice',
                    minWidth: 40,
                    maxWidth: 40,
                    onRender: (item, index) => {
                        return <React.Fragment>{index}</React.Fragment>

                    }
                },
                {
                    key: 'internalName',
                    fieldName: 'internalName',
                    name: 'InternalName',
                    minWidth: 100,
                    isResizable: true,
                    onRender: (item) => {
                        return (
                            <TooltipHost
                                key={`tooltip_intname_${item.internalName}`}
                                content={item.internalName}
                                styles={tooltipHostStyles}
                                overflowMode={TooltipOverflowMode.Self}
                            >
                                {item.internalName}
                            </TooltipHost>
                        );
                    }
                },
                /// Aggiungo una colonna vuota in coda alla tabella, è necessaria per consentire l'allineamneto tra
                /// l'header e i contenuti della tabella 
                {
                    key: 'empty',
                    name: 'empty',
                    fieldName: 'empty',
                    isIconOnly: true,
                    minWidth: 1,
                    maxWidth: 1,
                    onRender: (item) => {

                    },
                },
            ],
            lateralPanelIsOpen: false,
            lateralPanelBodyContent: () => { },
            lateralPanelSubmitFunction: () => { },
            confirmDialogIsOpen: false,
            confirmDialogContentProps: {},
            confirmDialogSubmitFunction: () => { },
            loadingAooProtocolViewsList: false,
            showMessageBar: false,
            userMessageError: "",
            showContextualMenu: false,
            contextMenuItems: [],
            contextMenuPosition: undefined
        }

    }

    handleMouseMove = (e: MouseEvent) => {
        const { lastMouseY } = this.state;
        if (lastMouseY !== undefined) {
            const direction = e.clientY > lastMouseY ? 'down' : e.clientY < lastMouseY ? 'up' : undefined;
            if (direction) this.setState({ mouseDirection: direction });
        }
        this.setState({ lastMouseY: e.clientY });
    };

    componentDidMount() {
        window.addEventListener('mousemove', this.handleMouseMove);

        this.unsubscribeFromAbility = abilityBuild.on('updated', () => {
            if (abilityBuild.cannot('read', 'IAooProtocolView')) {
                this.props.history.push({ pathname: '/unauthorized' });
            }
            this.updateCommandBarItems();
        });

        if (this.props.currentAoo) {
            this.updateCommandBarItems();
        }
        this.getAooProtocolViews();


    }

    componentDidUpdate(oldProps: Props, oldState: AooProtocolViewManagerState) {

        if (oldProps.currentAoo !== this.props.currentAoo
            || oldState.selectedColumnInternalName !== this.state.selectedColumnInternalName) {
            this.updateCommandBarItems();
        }

        if (oldProps.currentAoo !== this.props.currentAoo) {
            this.getAooProtocolViews();
        }

    }

    componentWillUnmount() {

        window.removeEventListener('mousemove', this.handleMouseMove);
        this.unsubscribeFromAbility();
    }

    getAooProtocolViews() {
        if (this.props.currentAoo) {
            this.setState({ loadingAooProtocolViewsList: true });
            aooProtocolViewsService.getAooProtocolViews(this.props.currentAoo?.id!)
                .then(aooProtocolViews => {
                    let aooProtocolView = { ...aooProtocolViews[0] }
                    let internalColumnNames = aooProtocolView.internalColumnNames.map(el => {
                        return { key: el, internalName: el }
                    });
                    this.setState({ aooProtocolViews: aooProtocolViews, selectedAooProtocolView: aooProtocolView, items: internalColumnNames, loadingAooProtocolViewsList: false })

                })
                .catch(error => {
                    this.setState({ loadingAooProtocolViewsList: false });
                    if (!error.isErrorShown) {
                        toastRef.current?.show({
                            severity: 'error',
                            summary: 'Attenzione',
                            detail: `Non è stato possibile recuperare le informazioni`,
                            life: 5000
                        });
                    }
                });
        }
    }

    updateCommandBarItems = () => {

        let newCommandBarItems: ICommandBarItemProps[] = [];

        if (abilityBuild.can('update', 'IAooProtocolView'))
            newCommandBarItems.push({
                key: 'editAooProtocolView',
                iconProps: { iconName: 'Add' },
                text: 'Aggiungi',
                onClick: this.editAooProtocolViewManagerHandler
            });

        this.setState({ commandBarItems: newCommandBarItems });
    }


    onRenderDetailsHeader = (detailsHeaderProps) => {
        const detailsListHeadrerStyles: Partial<IDetailsListStyles> = {

            root: { boxSizing: 'content-box !important' }

        };
        return (
            <DetailsHeader
                {...detailsHeaderProps}
                styles={detailsListHeadrerStyles}
            />
        );
    }


    getDragDropEvents = (): IDragDropEvents => {
        return {
            canDrop: (dropContext?: IDragDropContext, dragContext?: IDragDropContext) => {
                return true;
            },
            canDrag: (item?: any) => {
                return true;
            },
            onDragEnter: (item?: any, event?: DragEvent) => {
                const itemIndex = this.state.items.indexOf(item);
                let direction = itemIndex < this._draggedIndex ? 'up' : 'down';
                return direction === 'down' ? 'drag-from-top' : 'drag-from-bottom';
            },
            onDragLeave: (item?: any, event?: DragEvent) => {
                return;
            },
            onDrop: (item?: any, event?: DragEvent) => {
                if (this._draggedItem) {
                    this._insertBeforeItem(item);
                }
            },
            onDragStart: (item?: any, itemIndex?: number, selectedItems?: any[], event?: MouseEvent) => {
                this._draggedItem = item;
                this._draggedIndex = itemIndex!;
            },
            onDragEnd: (item?: any, event?: DragEvent) => {
                this._draggedItem = undefined;
                this._draggedIndex = -1;
                this.setState({ lastMouseY: undefined })
            },
        };
    }

    private _insertBeforeItem(item: IColumnInternalName): void {
        if (this.state.selectedAooProtocolView) {
            let { aooProtocolViews, selectedAooProtocolView } = this.state;
            const draggedItems = this.columnInternalNameSelection.isIndexSelected(this._draggedIndex)
                ? (this.columnInternalNameSelection.getSelection() as IColumnInternalName[])
                : [this._draggedItem!];

            const insertIndex = this.state.items.indexOf(item);
            const items = this.state.items.filter(itm => draggedItems.indexOf(itm) === -1);

            items.splice(insertIndex, 0, ...draggedItems);

            this.setState({ loadingAooProtocolViewsList: true });

            let aooId = Number(this.props.match.params["aooId"]);
            let updatedView = { ...selectedAooProtocolView, internalColumnNames: items.map(el => el.internalName) }

            let seletedViewIndex = aooProtocolViews.findIndex(el => el.id === updatedView.id);
            aooProtocolViews[seletedViewIndex] = { ...updatedView };

            aooProtocolViewsService.update(aooId, updatedView.id!, updatedView)
                .then(() => {
                    this.setState({ items, loadingAooProtocolViewsList: false });
                })
                .catch(error => {
                    this.setState({ loadingAooProtocolViewsList: false });
                    if (!error.isErrorShown) {
                        toastRef.current?.show({
                            severity: 'error',
                            summary: 'Attenzione',
                            detail: `Non è stato possibile aggiornare l'ordinamento`,
                            life: 5000
                        });
                    }
                });
        }
    }

    //// Click sul button della commandbar - Modifica aooProtocolView
    editAooProtocolViewManagerHandler = () => {
        let internalColumnNames: string[] = this.state.selectedAooProtocolView ? [...this.state.selectedAooProtocolView.internalColumnNames] : [];
        let campiProtocolloViewIndex = this.state.aooProtocolViews.findIndex(el => el.viewName === "Campi protocollo");
        let campiProtocolloView: IAooProtocolView = { ...this.state.aooProtocolViews[campiProtocolloViewIndex] };

        let campiProtocolloInternalColumnNames = this.state.selectedAooProtocolView?.viewName !== "Campi protocollo" ? campiProtocolloView.internalColumnNames : [];
        this.setState(
            {
                lateralPanelIsOpen: true,
                lateralPanelBodyContent: () => <AddEditAooProtocolViewManager
                    panelIsOpen={this.state.lateralPanelIsOpen}
                    panelHeaderText='Aggiungi una colonna'
                    loading={false}
                    onAddColumnToView={this.addColumnToView}
                    onDismiss={this.dismissLateralPanel}
                    internalColumnNames={internalColumnNames}
                    campiProtocolloInternalColumnNames={campiProtocolloInternalColumnNames}
                />
            }
        );
    }

    //// Click su salva del panel laterale - Modifica aooProtocolView
    addColumnToView = (colonna: IColonnaGenerale) => {
        let { selectedColumnInternalName } = this.state;
        const insertIndex = selectedColumnInternalName ? this.state.items.indexOf(selectedColumnInternalName) + 1 : 0;

        this.setState({
            lateralPanelIsOpen: false,
            confirmDialogIsOpen: true,
            confirmDialogContentProps: {
                type: DialogType.normal,
                title: 'Conferma',
                closeButtonAriaLabel: 'Close',
                subText: `Vuoi aggiungere alla visualizzazione la colonna "${colonna.displayName}" con indice ${insertIndex}?`,
            },
            confirmDialogSubmitFunction: () => { this.addColumnToViewConfirmDialogSubmit(colonna) }
        })
    }

    //// Click su conferma del confirm dialog - Modifica aooProtocolView
    addColumnToViewConfirmDialogSubmit = (colonna: IColonnaGenerale) => {
        if (this.state.selectedAooProtocolView) {
            this.setState({ loadingAooProtocolViewsList: true });
            let { aooProtocolViews, selectedAooProtocolView, selectedColumnInternalName, items } = this.state;
            let newColumn: IColumnInternalName = { internalName: colonna.internalName }

            const insertIndex = selectedColumnInternalName ? this.state.items.indexOf(selectedColumnInternalName) + 1 : 0;
            items.splice(insertIndex, 0, { ...newColumn });

            this.setState({ loadingAooProtocolViewsList: true });

            let aooId = Number(this.props.match.params["aooId"]);
            let updatedView = { ...selectedAooProtocolView, internalColumnNames: items.map(el => el.internalName) }

            let seletedViewIndex = aooProtocolViews.findIndex(el => el.id === updatedView.id);
            aooProtocolViews[seletedViewIndex] = { ...updatedView };

            aooProtocolViewsService.update(aooId, updatedView.id!, updatedView)
                .then(() => {
                    this.setState({
                        items: [...items],
                        aooProtocolViews: [...aooProtocolViews],
                        selectedAooProtocolView: { ...updatedView },
                        loadingAooProtocolViewsList: false
                    });
                    toastRef.current?.show({
                        severity: 'info',
                        summary: 'Operazione completata',
                        detail: `Colonne aggiornate correttamente`,
                        life: 5000
                    });

                })
                .catch(error => {
                    this.setState({ loadingAooProtocolViewsList: false });

                    if (!error.isErrorShown) {
                        toastRef.current?.show({
                            severity: 'error',
                            summary: 'Attenzione',
                            detail: `Non è stato possibile aggiornare le colonne`,
                            life: 5000
                        });
                    }
                });



            this.setState({ confirmDialogIsOpen: false, loadingAooProtocolViewsList: false });
            this.columnInternalNameSelection!.setAllSelected(false);
        }
    }

    // Click sul button della commandbar - Elimina
    deleteColumnHandler = (colonna: IColumnInternalName) => {
        this.setState(
            {
                lateralPanelIsOpen: false,
                confirmDialogIsOpen: true,
                confirmDialogContentProps: {
                    type: DialogType.normal,
                    title: 'Conferma',
                    closeButtonAriaLabel: 'Close',
                    subText: `Vuoi rimuovere la colonna "${colonna.internalName}"?`,
                },
                confirmDialogSubmitFunction: () => { this.deleteColumnConfirmDialogSubmit(colonna) }
            }
        );
    }

    // Click su conferma del confirm dialog - Elimina
    deleteColumnConfirmDialogSubmit = (colonna: IColumnInternalName) => {
        if (this.state.selectedAooProtocolView && colonna) {
            this.setState({ loadingAooProtocolViewsList: true });
            let { aooProtocolViews, selectedAooProtocolView, items } = this.state;

            const insertIndex = colonna ? this.state.items.indexOf(colonna) : 0;
            items.splice(insertIndex, 1);

            this.setState({ loadingAooProtocolViewsList: true });

            let aooId = Number(this.props.match.params["aooId"]);
            let updatedView = { ...selectedAooProtocolView, internalColumnNames: items.map(el => el.internalName) }

            let seletedViewIndex = aooProtocolViews.findIndex(el => el.id === updatedView.id);
            aooProtocolViews[seletedViewIndex] = { ...updatedView };

            aooProtocolViewsService.update(aooId, updatedView.id!, updatedView)
                .then(() => {
                    this.setState({
                        items: [...items],
                        aooProtocolViews: [...aooProtocolViews],
                        selectedAooProtocolView: { ...updatedView },
                        loadingAooProtocolViewsList: false
                    });
                    toastRef.current?.show({
                        severity: 'info',
                        summary: 'Operazione completata',
                        detail: `Colonne aggiornate correttamente`,
                        life: 5000
                    });

                })
                .catch(error => {
                    this.setState({ loadingAooProtocolViewsList: false });
                    if (!error.isErrorShown) {
                        toastRef.current?.show({
                            severity: 'error',
                            summary: 'Attenzione',
                            detail: `Non è stato possibile aggiornare le colonne`,
                            life: 5000
                        });
                    }
                });



            this.setState({ confirmDialogIsOpen: false, loadingAooProtocolViewsList: false });
            this.columnInternalNameSelection!.setAllSelected(false);
        }

    }


    dismissLateralPanel = (ev?: React.SyntheticEvent<HTMLElement, Event> | KeyboardEvent | undefined) => {
        ev?.preventDefault();
        ev?.stopPropagation();
        this.setState({ lateralPanelIsOpen: false })
    }

    dismissConfirmDialog = () => {
        this.setState({ confirmDialogIsOpen: false })
    }

    // metodi gestione context menu 
    onShowContextualMenu = (item, index, ev) => {
        ev.preventDefault();

        const menuItems = this.updateContextMenuAooProtocolViewManager();
        this.setState({ contextMenuItems: menuItems, showContextualMenu: true, contextMenuPosition: ev });
    };

    updateContextMenuAooProtocolViewManager = () => {
        const menuItems: IContextualMenuItem[] = [];

        if (abilityBuild.can('update', 'IAooProtocolView')) {
            menuItems.push(
                {
                    key: 'edit',
                    text: 'Modifica',
                    iconProps: { iconName: 'EditMail' },
                    onClick: () => {
                        this.editAooProtocolViewManagerHandler();
                        this.onHideContextualMenu();
                    }
                }
            );
        }
        return menuItems;
    };

    onHideContextualMenu = () => {
        this.setState({ contextMenuItems: undefined, showContextualMenu: false });
    };

    onPivotLinkClick(item?: PivotItem | undefined, ev?): void {
        let viewId = Number(item?.props.itemID);
        let view = this.state.aooProtocolViews.find(el => el.id === viewId);
        let internalColumnNames = view ? view.internalColumnNames.map(el => {
            return { key: el, internalName: el }
        }) : [];
        this.setState({ selectedAooProtocolView: view, items: internalColumnNames });
    }


    render() {


        return (
            <React.Fragment>
                {this.state.lateralPanelBodyContent()}

                <Dialog
                    hidden={!this.state.confirmDialogIsOpen}
                    onDismiss={this.dismissConfirmDialog}
                    dialogContentProps={this.state.confirmDialogContentProps}
                >
                    <DialogFooter>
                        <PrimaryButton onClick={() => this.state.confirmDialogSubmitFunction()} text="Conferma" />
                        <DefaultButton onClick={this.dismissConfirmDialog} text="Annulla" />
                    </DialogFooter>
                </Dialog>

                <div className="aoo-protocol-view-manager-component" >

                    {this.state.commandBarItems.length > 0 &&
                        <CommandBar
                            overflowButtonProps={overflowProps}
                            items={this.state.commandBarItems}
                            styles={commandBarStyles}
                        />
                    }
                    {this.state.showMessageBar &&
                        <MessageBar
                            messageBarType={MessageBarType.blocked}
                            isMultiline={true}
                            onDismiss={() => this.setState({ showMessageBar: false })}
                            dismissButtonAriaLabel="Close">
                            {this.state.userMessageError}
                        </MessageBar>
                    }


                    <CircleLoader loaderClass='loader-large' loading={this.state.loadingAooProtocolViewsList} />

                    <Pivot onLinkClick={this.onPivotLinkClick} styles={pivotStyles} className='pivot-container'>

                        {
                            this.state.aooProtocolViews.map((view, index) => {

                                return (
                                    <PivotItem
                                        key={`view_${index}`}
                                        itemID={String(view.id)}
                                        headerText={view.viewName}

                                    >
                                        <DetailsList
                                            className="with-empty-column"
                                            items={this.state.items}
                                            columns={this.state.columns}
                                            layoutMode={DetailsListLayoutMode.justified}
                                            onRenderDetailsHeader={this.onRenderDetailsHeader}
                                            selection={this.columnInternalNameSelection}
                                            selectionPreservedOnEmptyClick={true}
                                            selectionMode={SelectionMode.single}
                                            checkboxVisibility={CheckboxVisibility.onHover}
                                            onItemContextMenu={this.onShowContextualMenu}

                                            dragDropEvents={this._dragDropEvents}
                                        />
                                    </PivotItem>
                                );
                            })
                        }


                    </Pivot>

                    <ContextualMenu
                        items={this.state.contextMenuItems!}
                        hidden={!this.state.showContextualMenu}
                        target={this.state.contextMenuPosition}
                        onItemClick={this.onHideContextualMenu}
                        onDismiss={this.onHideContextualMenu}
                    />


                </div>

            </React.Fragment >
        )
    }
}

export default connector(checkRoles(AooProtocolViewManager, RoleContext.Aoo));